import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var MagicWandIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 16 16",
                    children: [
                        _jsx("g", {
                            clipPath: "url(#clip0_1014_243994)",
                            children: _jsx("path", {
                                d: "M11.76 5.75l-1.5-1.5a1.06 1.06 0 00-1.46 0l-7.41 7.4a1.06 1.06 0 00-.225 1.126 1 1 0 00.225.334l1.51 1.5a1 1 0 001.45 0l7.41-7.4a1 1 0 000-1.46zM8.52 8.57L7.44 7.49 9.53 5.4l1.07 1.08-2.08 2.09zM12.29.86l.1.39a1.4 1.4 0 001 1l.39.1a.33.33 0 010 .63l-.39.1a1.4 1.4 0 00-1 1l-.1.39a.33.33 0 01-.4.23.32.32 0 01-.22-.23L11.56 4a1.39 1.39 0 00-1-1h-.37a.32.32 0 01-.22-.4.32.32 0 01.22-.23l.39-.1a1.39 1.39 0 001-1l.11-.39a.32.32 0 01.39-.23.33.33 0 01.21.21zM14 7.49l.09.32a1.16 1.16 0 00.81.82l.33.09a.27.27 0 01.19.33.3.3 0 01-.19.19l-.33.09a1.13 1.13 0 00-.81.81l-.09.33a.27.27 0 01-.33.19.28.28 0 01-.19-.19l-.09-.33a1.14 1.14 0 00-.82-.81l-.32-.09a.27.27 0 01-.25-.33.25.25 0 01.19-.19l.32-.09a1.17 1.17 0 00.82-.82l.09-.32a.27.27 0 01.33-.19.28.28 0 01.25.19zM6.85 2.12l.07.26a.92.92 0 00.66.62l.26.07a.21.21 0 01.16.3.23.23 0 01-.15.15l-.26.07a1 1 0 00-.66.66l-.07.26a.22.22 0 01-.26.15.24.24 0 01-.16-.15l-.07-.26a.92.92 0 00-.65-.66l-.26-.07a.22.22 0 010-.42l.25-.1a.89.89 0 00.65-.65l.07-.26A.23.23 0 016.7 2a.2.2 0 01.15.12z"
                            })
                        }),
                        _jsx("defs", {
                            children: _jsx("clipPath", {
                                id: "clip0_1014_243994",
                                children: _jsx("path", {
                                    d: "M0 0h16v16H0z"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
MagicWandIcon.isCarinaIcon = true;
export default MagicWandIcon;
